import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EventEmitter } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'chart.js';

if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule);
